<template>
  <SoPage>
    <SoAlert type="error" title="Page not found">
      It looks like you've reached a page that doesn’t exist. Please use the
      navigation menu or
      <router-link to="/" class="primary">click here</router-link>
      to return to the home page.
    </SoAlert>
  </SoPage>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoPage from "@/components/templates/SoPage.vue"

  export default defineComponent({
    components: {
      SoAlert,
      SoPage,
    },
  })
</script>
